import React from "react";
import { Link } from "react-router-dom";
import "./blogsCard.css";
// images
import dummy from "../../assets/images/banner.jpg";

function BlogsCard({ blog_data }) {
  return (
    <React.Fragment>
      <Link to={`/editblog/${blog_data?.slug}`} className="block no-underline bg-white text-black">
        <div className="blogCardWrapper shadow cursor-pointer mb-4 hover:no-underline">
          <div className="blogCoverImage w-full overflow-hidden blog-innerShadow border-b border-solid border-gray-300">
            <img
              src={blog_data?.banner_image ? blog_data.banner_image : dummy}
              alt="blogsCoverImage"
              className="blogsCoverImage object-cover h-56 w-full"
            />
          </div>
          <div className="blodDetailMini flex flex-col p-3">
            <div className="blogtitle">
              <h4 className="text-xl no-underline hover:no-underline text-black wordClamp">
                {blog_data.blog_title}
              </h4>
            </div>
            <div className="flex justify-around bg-gray-100 rounded-md px-2 py-2 mb-3">
              <div className="flex flex-col text-center">
                <small className="text-gray-600 manpro font-semibold">Likes</small>
                <span className="block manpro font-semibold text-base" style={{ color: "#000" }}>
                  {blog_data.stats.like_count}
                </span>
              </div>
              <div className="flex flex-col text-center">
                <small className="text-gray-600 manpro font-semibold">Comments</small>
                <span className="block manpro font-semibold text-base" style={{ color: "#000" }}>
                  {blog_data.stats.comment_count}
                </span>
              </div>
              <div className="flex flex-col text-center">
                <small className="text-gray-600 manpro font-semibold">Views</small>
                <span className="block manpro font-semibold text-base" style={{ color: "#000" }}>
                  {blog_data.stats.view_count}
                </span>
              </div>
            </div>
          </div>
        </div>
      </Link>
    </React.Fragment>
  );
}

export default BlogsCard;
